import { usePlatformNotificationsStore } from "@/store/platformNotificationsStore";
import { useCommonTranslation } from "@/services/culture/common.translations";
import { IconButton, StaticTooltipHost } from "@vintecc/components";
import { faEye, faBarsStaggered } from "@vintecc/pro-light-svg-icons";
import { useShallow } from "zustand/react/shallow";
import { PlatformNotification } from "./PlatformNotification";

export const PlatformNotificationsList = ({ onClose }: { onClose?: () => void }) => {
  const { t: tCommon } = useCommonTranslation();
  const { notifications, hasRemovable, hasUnread, removeAllNotifications, markAllAsRead } = usePlatformNotificationsStore(
    useShallow((s) => ({
      hasUnread: s.hasUnread,
      notifications: s.notifications,
      hasRemovable: s.hasRemovable,
      removeAllNotifications: s.removeAllNotifications,
      markAllAsRead: s.markAllAsRead,
    })),
  );

  return (
    <div className="rounded-lg shadow-(--shadow-elevation-low) w-96 max-h-96 bg-white">
      <div className="flex justify-between items-center p-2 border border-(--theme-border-color) rounded-t-lg">
        <div className="font-bold ps-2">{tCommon("topbar.notifications")}</div>
        <div className="flex">
          <StaticTooltipHost
            tooltip={tCommon(hasUnread ? "topbar.notificationsMarkAllRead" : "topbar.notificationsAllRead")}
            place="top"
            customStyling={{ fill: "var(--background-navigation)", textColor: "var(--color-white)" }}
          >
            <IconButton
              iconName={faEye}
              type="button"
              naked
              size="xs"
              onClick={markAllAsRead}
              aria-label={tCommon("topbar.notificationsMarkAllRead")}
              disabled={!hasUnread}
            />
          </StaticTooltipHost>
          {hasRemovable && (
            <StaticTooltipHost
              tooltip={tCommon("topbar.notificationsClearAll")}
              place="top"
              customStyling={{ fill: "var(--background-navigation)", textColor: "var(--color-white)" }}
            >
              <IconButton
                iconName={faBarsStaggered}
                type="button"
                naked
                size="xs"
                onClick={removeAllNotifications}
                aria-label={tCommon("topbar.notificationsClearAll")}
              />
            </StaticTooltipHost>
          )}
        </div>
      </div>
      <ul className="divide-y divide-(--theme-border-color) max-h-84 overflow-y-auto rounded-b-lg border border-(--theme-border-color) border-t-0">
        {notifications.length === 0 && <li className="px-2 py-6 text-center text-grey-400">{tCommon("topbar.notificationsEmpty")}</li>}
        {notifications.map((n) => (
          <PlatformNotification key={n.id} notification={n} onClose={onClose} />
        ))}
      </ul>
    </div>
  );
};
